import { useEffect } from 'react';
import { Loader } from '../Common/Loader';
import { InternalMessageEventsName } from '@/constants/iframeMessages';
import { getApmDynamicPageOrigin } from '@/utils/redirectPayment';

export const ApmDynamicPage = () => {
  useEffect(() => {
    const eventHandler = (massageEvent: MessageEvent) => {
      const { params, event } = massageEvent.data;
      const checkoutDomain = getApmDynamicPageOrigin();
      if (massageEvent.origin !== checkoutDomain) return;

      if (event === InternalMessageEventsName.APM_REDIRECT) {
        window.location.href = params.url;
      }
      if (event === InternalMessageEventsName.APM_REDIRECT_CLOSE) {
        window.close();
      }
    };

    window.addEventListener('message', eventHandler);

    return () => {
      window.removeEventListener('message', eventHandler);
    };
  }, []);
  return (
    <div className="flex items-center justify-center h-screen">
      <Loader size="lg" variant="checkout" />
    </div>
  );
};
